class Node {
  constructor(value, _prev = null, raw = null) {
    this.value = value;
    this.raw = raw;
    this._prev = _prev;
  }

  /**
   * 前のnodeをセットする
   * @param {object} node - セットするnode
   */
  setPrev(node) {
    this._prev = node;
  }
}


/**
 * 検索indexの制作
 * @param {object} data - 制作するためのソース
 */
class SearchIndex {
  constructor() {
    this.hashMap = {};
  }

  buildPathIndex(data, prev = null) {
    let keys = Object.keys(data);
    let currentNode = null;
    keys.map(key => {
      let item = data[key];
      if(typeof(item) == 'object') {
        // 連結リストを制作してprevをセット
        currentNode = this.createNode(prev, key, item);

        if(prev !== 'child' && prev !== 'all') {
          // ハッシュマップに登録
          this.hashMap[key] = currentNode;
        };

        this.buildPathIndex(item, currentNode);
      }
    });

    return;
  }


  createNode(prev, node, raw) {
    let currentNode = null;
    if(prev != null) {
      currentNode = new Node(node);
      currentNode.setPrev(prev);
      currentNode.raw = raw;
    } else {
      currentNode = new Node(node);
      currentNode.raw = raw;
    }
    return currentNode;
  }
}

export default SearchIndex;